module.exports = require('./lib/role-select-dialog.js');
